import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d71ce3f0 = () => interopDefault(import('../../../pages/contact-opnemen/index.vue' /* webpackChunkName: "pages/contact-opnemen/index" */))
const _01e33d2f = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/index.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/index" */))
const _54ab4a32 = () => interopDefault(import('../../../pages/informatie-over-dakkapellen.vue' /* webpackChunkName: "pages/informatie-over-dakkapellen" */))
const _1e837b70 = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/bevestigd" */))
const _2d5bb7c9 = () => interopDefault(import('../../../pages/contact-opnemen/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen/bevestigd" */))
const _4629efc5 = () => interopDefault(import('../../../pages/offertes-aanvragen/aanvraag-afgerond.vue' /* webpackChunkName: "pages/offertes-aanvragen/aanvraag-afgerond" */))
const _e28faa36 = () => interopDefault(import('../../../pages/offertes-aanvragen/gewenste-breedte-dakkapel.vue' /* webpackChunkName: "pages/offertes-aanvragen/gewenste-breedte-dakkapel" */))
const _12e3723a = () => interopDefault(import('../../../pages/offertes-aanvragen/hellingshoek-van-dak.vue' /* webpackChunkName: "pages/offertes-aanvragen/hellingshoek-van-dak" */))
const _2af4da01 = () => interopDefault(import('../../../pages/offertes-aanvragen/je-gegevens.vue' /* webpackChunkName: "pages/offertes-aanvragen/je-gegevens" */))
const _75192cc2 = () => interopDefault(import('../../../pages/offertes-aanvragen/locatie-dakkapel.vue' /* webpackChunkName: "pages/offertes-aanvragen/locatie-dakkapel" */))
const _b9e64136 = () => interopDefault(import('../../../pages/offertes-aanvragen/type-dakkapel.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-dakkapel" */))
const _7d587850 = () => interopDefault(import('../../../pages/offertes-aanvragen/wanneer-dakkapel-plaatsen.vue' /* webpackChunkName: "pages/offertes-aanvragen/wanneer-dakkapel-plaatsen" */))
const _10cf8bc6 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _0b412bf8 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.nl.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-opnemen",
    component: _d71ce3f0,
    name: "contact-opnemen"
  }, {
    path: "/contact-opnemen-bedrijf",
    component: _01e33d2f,
    name: "contact-opnemen-bedrijf"
  }, {
    path: "/informatie-over-dakkapellen",
    component: _54ab4a32,
    name: "informatie-over-dakkapellen"
  }, {
    path: "/contact-opnemen-bedrijf/bevestigd",
    component: _1e837b70,
    name: "contact-opnemen-bedrijf-bevestigd"
  }, {
    path: "/contact-opnemen/bevestigd",
    component: _2d5bb7c9,
    name: "contact-opnemen-bevestigd"
  }, {
    path: "/offertes-aanvragen/aanvraag-afgerond",
    component: _4629efc5,
    name: "offertes-aanvragen-aanvraag-afgerond"
  }, {
    path: "/offertes-aanvragen/gewenste-breedte-dakkapel",
    component: _e28faa36,
    name: "offertes-aanvragen-gewenste-breedte-dakkapel"
  }, {
    path: "/offertes-aanvragen/hellingshoek-van-dak",
    component: _12e3723a,
    name: "offertes-aanvragen-hellingshoek-van-dak"
  }, {
    path: "/offertes-aanvragen/je-gegevens",
    component: _2af4da01,
    name: "offertes-aanvragen-je-gegevens"
  }, {
    path: "/offertes-aanvragen/locatie-dakkapel",
    component: _75192cc2,
    name: "offertes-aanvragen-locatie-dakkapel"
  }, {
    path: "/offertes-aanvragen/type-dakkapel",
    component: _b9e64136,
    name: "offertes-aanvragen-type-dakkapel"
  }, {
    path: "/offertes-aanvragen/wanneer-dakkapel-plaatsen",
    component: _7d587850,
    name: "offertes-aanvragen-wanneer-dakkapel-plaatsen"
  }, {
    path: "/",
    component: _10cf8bc6,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/privacy",
    component: _861e7d2c,
    name: "privacy"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/algemene-voorwaarden",
    component: _0b412bf8,
    name: "algemene-voorwaarden"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
